import React, { useState } from 'react';
import { FaTabletAlt, FaBarcode, FaSimCard, FaPhoneSquare, FaExclamationTriangle } from 'react-icons/fa';
import axiosInstance from '../utils/axiosConfig';
import { Modal } from './common';
import './FormModal.css';

const MARCAS_TABLETS = [
  'Samsung',
  'Apple',
  'Lenovo',
  'Huawei',
  'Amazon',
  'Xiaomi',
  'Siragon',
  'Soneview'
];

function AddTabletModal({ isOpen, onClose, onAdd }) {
  const [formData, setFormData] = useState({
    marca: '',
    modelo: '',
    serial: '',
    imei: '',
    linea: '',
    estado: 'Disponible',
    activo_fijo: ''
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await axiosInstance.post('/api/tablets', formData);
      onAdd(response.data.tablet);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Error al crear la tablet');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen !== undefined ? isOpen : true} onClose={onClose} size="lg">
      <Modal.Header onClose={onClose}>Agregar Nueva Tablet</Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} id="add-tablet-form">
          <div className="form-modal-section">
            <h3><FaTabletAlt /> Información de la Tablet</h3>
            <div className="form-modal-grid">
              <div className="form-modal-group">
                <label htmlFor="marca">
                  <FaTabletAlt className="input-icon" /> Marca
                </label>
                <select
                  id="marca"
                  name="marca"
                  value={formData.marca}
                  onChange={handleChange}
                  required
                >
                  <option value="">Seleccione una marca</option>
                  {MARCAS_TABLETS.map(marca => (
                    <option key={marca} value={marca}>{marca}</option>
                  ))}
                </select>
              </div>

              <div className="form-modal-group">
                <label htmlFor="modelo">
                  <FaTabletAlt className="input-icon" /> Modelo
                </label>
                <input
                  type="text"
                  id="modelo"
                  name="modelo"
                  value={formData.modelo}
                  onChange={handleChange}
                  required
                  placeholder="Ej: Galaxy Tab A9"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="serial">
                  <FaBarcode className="input-icon" /> Serial
                </label>
                <input
                  type="text"
                  id="serial"
                  name="serial"
                  value={formData.serial}
                  onChange={handleChange}
                  required
                  placeholder="Ej: ABC123XYZ"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="activo_fijo">
                  <FaBarcode className="input-icon" /> Activo Fijo
                </label>
                <input
                  type="text"
                  id="activo_fijo"
                  name="activo_fijo"
                  value={formData.activo_fijo}
                  onChange={handleChange}
                  placeholder="Ej: 1234"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="imei">
                  <FaSimCard className="input-icon" /> IMEI
                </label>
                <input
                  type="text"
                  id="imei"
                  name="imei"
                  value={formData.imei}
                  onChange={handleChange}
                  placeholder="Opcional - 15 dígitos"
                  maxLength="15"
                  pattern="[0-9]*"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="linea">
                  <FaPhoneSquare className="input-icon" /> Línea Telefónica
                </label>
                <input
                  type="text"
                  id="linea"
                  name="linea"
                  value={formData.linea}
                  onChange={handleChange}
                  placeholder="Opcional"
                />
              </div>
            </div>
          </div>

          {error && (
            <div className="form-modal-error">
              <FaExclamationTriangle />
              {error}
            </div>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={onClose} className="btn btn-secondary">
          Cancelar
        </button>
        <button type="submit" form="add-tablet-form" className="btn btn-primary" disabled={loading}>
          {loading ? 'Guardando...' : 'Guardar'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddTabletModal;
